import { StyledModal } from '@app/components/modal/Modal';
import useAgentActions from '@app/hooks/agents/useAgentActions';
import type { AINumber } from '@app/services/api.types';
import type { ModalProps } from 'antd';
import { type AgentFormValues } from './AgentForm';
import AssignAiAgentForm from './AssignAiAgentForm';

export type AgentEditModalProps = ModalProps & {
    title?: string;
    data?: AINumber;
};

export const AgentEditModal = ({
    title = 'Edit AI Agent',
    data,
    onOk,
    ...props
}: AgentEditModalProps) => {
    const { editAgent } = useAgentActions();
    // Reset the component if closed
    if (!props.open) {
        return null;
    }

    const handleSubmit = (values: AgentFormValues & { channel_id: string }) => {
        if (data) {
            const formData = { ...values, id: data.id };
            editAgent.mutate(formData, {
                onSuccess: () => {
                    if (onOk) {
                        onOk(undefined as unknown as React.MouseEvent<HTMLButtonElement>);
                    }
                },
            });
        }
    };

    return (
        <StyledModal
            title={title}
            mask={{ closable: false }}
            width={680}
            footer={null}
            className="modal-body-scroll"
            {...props}>
            <AssignAiAgentForm
                id="ai-numbers-edit"
                data={data}
                onCancel={props.onCancel}
                loading={editAgent.isPending}
                onSubmit={handleSubmit}
            />
        </StyledModal>
    );
};
